import React, { useState, useEffect } from "react";

import { Card } from "@mui/material";
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { loadMembersFromBackendForClient } from "app/services/member.service";
import { checkUserHasClientRole, getLoggedInUserId } from "app/services/app.state.service";
import { loadClientByClientUserId } from "app/services/client.service";
import { handleAxiosError } from "app/services/app.error.handler";
import { TeamMemberDataGridBase } from "./TeamMemberDataGridBase";
import MemberActivityDataGridView from "../team-activities/MemberActivityDataGridView";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "store/member-slice";

export const TeamMembersClientView = () => {
    const dispatch = useDispatch();
    const [selectedMember, setSelectedMember] = useState(null);
    const membersData = useSelector((state) => state.member.rows);
    const [isLoading, setIsLoading] = useState(false);


    const selectMemberHandler = (memberObj) => {
        setSelectedMember(memberObj);
    }

    useEffect(() =>  {
        if(!checkUserHasClientRole()) return;

        if(membersData.length === 0)
        {
           
        setIsLoading(true);
        
        var userId = getLoggedInUserId();

        loadClientByClientUserId(userId)
        .then(clientResponseObj => clientResponseObj.data.id)
        .then(clientId => {
            loadMembersFromBackendForClient(clientId)
            .then(response => {
                dispatch(memberActions.replaceData(response.data));
                setIsLoading(false);})
            .catch(error=>{ 
                setIsLoading(false);
                dispatch(memberActions.replaceData([])); // Set the empty data in activity table
                handleAxiosError(error);      
            });
        });
    }
    }, [dispatch, membersData.length]);

    if(!checkUserHasClientRole()) {
        return <div>You do not have access to this functionality.</div>;
    }
    
    return (
        <div
            className="content-container"
            style={{ width: "100%", minWidth: 0, padding: "0 16px", boxSizing: "border-box" }}
        >
            <Card>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={1}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white">
                        Client Team Members
                    </MDTypography>
                </MDBox>

                <TeamMemberDataGridBase membersData={membersData} isLoading={isLoading} clickEventHandler={selectMemberHandler}/>
            </Card>
            {selectedMember && (
                <div style={{ marginTop: 24 }}>
                    <MemberActivityDataGridView selectedMember={selectedMember}/>
                </div>
            )}
        </div>

    );
};